module.exports = __webpack_public_path__ + "img/arrow-up-icon.20a52062.svg";